import React from "react";
import { Languages } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";

export default function LanguageToggle({ compact = false }) {
    const { lang, toggle, t } = useI18n();
    return (
        <button
            type="button"
            onClick={toggle}
            className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-3 py-1.5 text-sm font-medium text-foreground hover:bg-secondary transition-colors"
            data-testid="language-toggle"
            aria-label={t("common.language")}
        >
            <Languages className="h-4 w-4" />
            {compact ? (lang === "en" ? "AR" : "EN") : (lang === "en" ? t("common.arabic") : t("common.english"))}
        </button>
    );
}
